import type { InputHTMLAttributes } from 'react';
import { Icon, type IconName } from './Icon';

export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> & {
  label?: string;
  icon?: IconName;
  onChange?: (value: string) => void;
};

export function Input({ label, icon, onChange, className = '', id, ...rest }: InputProps) {
  const inputEl = (
    <input
      id={id}
      className={`input ${icon ? 'has-icon' : ''} ${className}`}
      onChange={(e) => onChange?.(e.target.value)}
      {...rest}
    />
  );
  const wrapped = icon ? (
    <div className="input-wrap">
      <span className="input-icon">
        <Icon name={icon} size={14} />
      </span>
      {inputEl}
    </div>
  ) : (
    inputEl
  );
  if (!label) return wrapped;
  return (
    <div>
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      {wrapped}
    </div>
  );
}
